/**
 * PolicyRowDeleteAction — the Policen-tab "Aktionen" cell (DMS Part2 P2-13,
 * dms/spec-part2-stefan-delta.md §1.3): resolves the row's policy to its CURRENT
 * document, then renders the shared `DeleteDocumentButton`, which re-checks that
 * document's live state and the `document.delete` permission before showing anything.
 *
 * Zero-cost for a non-admin viewer: the version-chain lookup only fires once
 * `perms.can('document.delete')` is true.
 *
 * [Source: apps/web/src/features/entity-detail/hooks/useEntityDetail.ts#usePolicyCurrentDocumentState]
 * [Source: apps/web/src/features/documents/components/DeleteDocumentButton.tsx]
 */
import { useEffectivePermissions } from '../../administration/useEffectivePermissions';
import { DeleteDocumentButton } from '../../documents/components/DeleteDocumentButton';
import { usePolicyCurrentDocumentState } from '../hooks/useEntityDetail';
import type { Policy } from '../types';

/** `readOnly`: the customer is inaktiv (write-protected), so no delete is offered. */
export function PolicyRowDeleteAction({ policy, readOnly = false }: { policy: Policy; readOnly?: boolean }) {
  const perms = useEffectivePermissions();
  const canDelete = perms.can('document.delete') && !readOnly;
  const { sourceDocumentId } = usePolicyCurrentDocumentState(policy.id, canDelete);

  if (!canDelete || !sourceDocumentId) return null;

  return <DeleteDocumentButton documentId={sourceDocumentId} label={`Police ${policy.nr}`} />;
}
